import { AnimatePresence, motion} from 'framer-motion'
import { useDispatch } from 'react-redux'

//css
import './css/skills.css'
import './css/skill0.css'

const Skill0 = ({ width, skillCounter, animatinDir }) => {
	console.log(animatinDir)
	const dispatch = useDispatch()
	return(
				<motion.div 
					initial={animatinDir==="right"?{opacity:0,left:"100%"}:{opacity:0,left:"-100%"}}
					animate={{opacity:1, left:"50%"}}
					transition={{duration:1}}
					exit={{opacity:0}}
				className="skill" 
				id="skill0">
					<div className="skill_head">
						<p>frontend</p>
					</div>
					<div className="skill_body">

						<div id="skill_0_head">
						I will design your frontend using one of this 
						</div>

						<div id="skill_0_body" >
							<div>
								<i className="fab fa-js"></i>
								<ul>
									<li><i className="fas fa-check"></i><p>HTML, CSS & JS</p></li>
									<li><i className="fas fa-check"></i><p>Easy & lightweight</p></li>
									<li><i className="fas fa-check"></i><p>adjustible</p></li>
								</ul>
							</div>

							<div>
								<i className="fab fa-react"></i>
								<ul>
									<li><i className="fas fa-check"></i><p>Best framwork</p></li>
									<li><i className="fas fa-check"></i><p>Flexible & reactive</p></li>
									<li><i className="fas fa-check"></i><p>Fast and optimized</p></li>
								</ul>
							</div>
						</div>

						<div className="skill_footer">
							<i className="fas fa-info-circle"></i>most mdern web sites nowadays are buit in React !
						</div>
					</div>
				</motion.div>
		)
}

export default Skill0